export const shadows = {
	none: 'none',
	xs: '0px 4px 8px rgba(0, 0, 0, 0.12)',
	sm: '0 5px 10px rgba(0, 0, 0, 0.12)',
	md: '0 8px 30px rgba(0, 0, 0, 0.12)',
	lg: '0 30px 60px rgba(0, 0, 0, 0.12)',
	xl: '0 30px 60px rgba(0, 0, 0, 0.12)',
	legacy: {
		sm: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
		md: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
		lg: '0 1rem 3rem rgba(0, 0, 0, 0.175)',
	},
};
